$(document).on('click', '[data-checkout-ariba-customer]', function() {
  const $this = $(this);
  const disabled = $this.val() === 'swisscom';
  const required = !disabled;
  $('#id_custom_personnel_no').prop('disabled', disabled).prop('required', required);
  $('#id_custom_cost_center').prop('disabled', disabled).prop('required', required);
  $('#id_custom_clean_service_id').prop('disabled', disabled).prop('required', required);
  $('#id_custom_ariba_email_address').prop('disabled', disabled).prop('required', required);
  $this.closest('form').find(`labelis-invalid-label`).removeClass('is-invalid-label');

  if (disabled) {
    $('#id_cablex-text').addClass('ariba-customer__hidden');
    $('#id_cablex-pers').addClass('ariba-customer__hidden');
    $('#id_cablex-cost').addClass('ariba-customer__hidden');
    $('#id_cablex-service').addClass('ariba-customer__hidden');
    $('#id_cablex-email').addClass('ariba-customer__hidden');
  } else {
    $('#id_cablex-text').removeClass('ariba-customer__hidden');
    $('#id_cablex-pers').removeClass('ariba-customer__hidden');
    $('#id_cablex-cost').removeClass('ariba-customer__hidden');
    $('#id_cablex-service').removeClass('ariba-customer__hidden');
    $('#id_cablex-email').removeClass('ariba-customer__hidden');
  }
});


$(document).on('click', '[data-checkout-ariba-axpo-customer]', function() {
  const $this = $(this);
  const disabled = $this.val() === 'axpo_no_service';

  const required = !disabled;
  $('#id_custom_axpo_personnel_no').prop('disabled', disabled).prop('required', required);
  $('#id_custom_axpo_cost_center').prop('disabled', disabled).prop('required', required);
  $('#id_custom_clean_axpo_service_id').prop('disabled', disabled).prop('required', required);
  $('#id_custom_ariba_email_address').prop('disabled', disabled).prop('required', required);
  $this.closest('form').find(`labelis-invalid-label`).removeClass('is-invalid-label');

  if (disabled) {
    $('#id_axpo-text').addClass('ariba-customer__hidden');
    $('#id_axpo-pers').addClass('ariba-customer__hidden');
    $('#id_axpo-cost').addClass('ariba-customer__hidden');
    $('#id_axpo-service').addClass('ariba-customer__hidden');
    $('#id_axpo-email').addClass('ariba-customer__hidden');
  } else {
    $('#id_axpo-text').removeClass('ariba-customer__hidden');
    $('#id_axpo-pers').removeClass('ariba-customer__hidden');
    $('#id_axpo-cost').removeClass('ariba-customer__hidden');
    $('#id_axpo-service').removeClass('ariba-customer__hidden');
    $('#id_axpo-email').removeClass('ariba-customer__hidden');
  }
});
